/**
 * index
 * Alerts
 * @author Oliver Boermans
 */
 import debug from "debug";
 const MODULE_NAME = 'alerts';
 const log = debug(MODULE_NAME);

import dismiss from './dismiss';
import reveal from './reveal';


export default function exec () {
	//	Run reveal before dismiss to ensure events are bound
	reveal();
	dismiss();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/alerts/index.js